import { BaseIcon, BaseIconProps } from '../BaseIcon';

export type ContractValueIconProps = Omit<BaseIconProps, 'children'>;

export const ContractValueIcon = ({ ...props }: ContractValueIconProps) => (
  <BaseIcon width="24" height="24" viewBox="0 0 24 24" hasLegacyStrokeStyles={true} {...props}>
    <g fill="none">
      <path d="M17.5242 6.41049H13.3208V2.20711L17.5242 6.41049Z" />
      <path d="M12.8208 1V6.91049H18.7313" strokeWidth="2" strokeMiterlimit="10" />
      <g strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square">
        <path d="M4.94043 6.91064H8.88076" />
        <path d="M4.94043 11.8359H9.86584" />
        <path d="M4.94043 16.7617H8.88076" />
        <path d="M18.7315 9.86574V6.91049L12.821 1H1V22.6718H10.8508" />
      </g>
      <g strokeWidth="1.5" strokeLinecap="round">
        <path d="M16.7612 12.4922V22.9997" />
        <path d="M19.388 15.7763C19.388 14.4629 18.0746 13.8062 16.7612 13.8062C15.4477 13.8062 14.1343 14.4629 14.1343 15.7763C14.1343 17.0898 15.4477 17.7465 16.7612 17.7465" />
        <path d="M14.1347 19.7164C14.1347 21.0298 15.4481 21.6865 16.7615 21.6865C18.075 21.6865 19.3884 21.0298 19.3884 19.7164C19.3884 18.4029 18.075 17.7462 16.7615 17.7462" />
      </g>
    </g>
  </BaseIcon>
);

ContractValueIcon.displayName = 'ContractValueIcon';
